import { companyMissionTrns } from "./trns";

export const COMPANY_MISSION_PARAGRAPHS = [
  {
    id: 1,
    text: {
      i18nKey: companyMissionTrns.paragraphFirst
    },
  },
  {
    id: 2,
    text: {
      i18nKey: companyMissionTrns.paragraphSecond
    },
  },
  {
    id: 3,
    text: {
      i18nKey: companyMissionTrns.paragraphThird
    },
  },
  {
    id: 4,
    text: {
      i18nKey: companyMissionTrns.paragraphFourth
    },
  },
  {
    id: 5,
    text: {
      i18nKey: companyMissionTrns.paragraphFifth
    },
  },
  {
    id: 6,
    text: {
      i18nKey: companyMissionTrns.paragraphSixth
    },
  },
  {
    id: 7,
    text: {
      i18nKey: companyMissionTrns.paragraphSeventh
    },
  },
]